import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import { CardContent, CardHeader, FormControl, Input, InputLabel, FormHelperText, Button, AppBar } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  content: {
    color: theme.palette.primary.contrastText,
  },
  textField: {
    flexBasis: 200,
    marginRight: 20
  },
  button: {
    marginTop: 20
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: '10vh',
    left: 0,
    right: 0,
    width: '90%',
    maxWidth: '400px',
    maxHeight: '80vh',
    margin: 'auto',
  },
});

class Login extends Component {

  state = {
    error: false
  };

  submit = (e) => {
    e.preventDefault();
    if(this.props.auth(document.getElementById('password-input').value)) {
      this.setState({error: false});
    } else {
      this.setState({error: true});
    }
    return false;
  }

  render() {
    const {classes, open} = this.props;
    const {error} = this.state;

    return (
      <Modal open={open}>
        <Card className={classes.paper} style={{ maxHeight: '80vh', width: '50vh'}}>
          <AppBar position='static'>
            <CardHeader
            classes={{
              title: classes.content,
              subheader: classes.content,
            }}
            title="Password Log in"
            subheader="Enter the password provided to you by your school"
            />
          </AppBar>
          <CardContent style={{position: 'relative', height: '100%', maxHeight: '63vh', overflowY: 'auto'}} >
            <form onSubmit={this.submit}>
              <FormControl className={classes.textField} error={error}>
                <InputLabel htmlFor="password-input">Password</InputLabel>
                <Input
                  id="password-input"
                  type="password"
                  autoComplete="current-password"
                  aria-describedby="component-error-text"
                />
                {error ?
                  <FormHelperText id="component-error-text">Incorrect Password</FormHelperText>
                : null }
              </FormControl>
              <Button
                variant='contained'
                size='small'
                className={classes.button}
                onClick={this.submit}
              >
                Log In
              </Button>
            </form>
          </CardContent>
        </Card>
      </Modal>
    )
  }
}

export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js